import { useEffect, useMemo } from "react";
import { useRouteLoaderData } from "react-router-dom";
import { BaseCustomSelector } from "components/base-custom-selector";
import { usePropertyTenancy } from "contexts/property-tenancy-provider";
import type { TenantSettingsLoaderData } from "types/tenancy";

export function PropertySelector() {
  const { setPropertyTenancyId, propertyTenancyId: selectedPropertyTenancy } =
    usePropertyTenancy();

  const data = useRouteLoaderData("tenant-root") as TenantSettingsLoaderData;

  const propertyTenancies = useMemo(() => data?.tenantProperties ?? [], [data]);

  useEffect(() => {
    if (propertyTenancies.length === 0) return;

    const exists = propertyTenancies.some(
      (p) => String(p.id) === selectedPropertyTenancy,
    );

    if (!selectedPropertyTenancy || !exists) {
      setPropertyTenancyId(String(propertyTenancies[0].id));
    }
  }, [propertyTenancies, selectedPropertyTenancy, setPropertyTenancyId]);

  const groups = [
    {
      label: { id: "renting", value: "Renting" },
      options: propertyTenancies.map((l) => ({
        label: l.property_display_name,
        value: String(l.id),
      })),
    },
  ];

  return (
    <BaseCustomSelector
      selectedValue={selectedPropertyTenancy}
      optionGroups={groups}
      handleOnChange={(value) => {
        setPropertyTenancyId(value);
      }}
      title={"Property"}
    />
  );
}
